module.exports = __webpack_public_path__ + "static/media/thumbs-up.a820528a.png";